<template>
  <div class="play-progress-box show-flex-box-r">
    <div class="progress-time-box">
      <span></span>
      <strong>{{progressTimeStr}}</strong>
    </div>
    <div class="progress-content">
      <!-- 进度条 strong -->
      <strong></strong> 
      <!-- 圆形拖动 -->
      <span></span>
      <!-- 鼠标移动竖线 -->
      <em></em>
      <!-- <el-slider class="el-progress-box" v-model="value2"></el-slider> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'player_progress_cpn',
  props: {
    totalTime:[Number,String],
    percentNumber: [Number,String],
    fullStatus: [Boolean]
  },
  data () {
    return {
      totalTimeObj: null,
      progressLeft: 0,
      progressWidth: 0,
      dragWidth: 0,
      referTimeWidth: 0,
      showStatus: true,
      progressTimeStr: '',
      zoomSize: 1
    }
  },
  mounted() {
    this.bindMouseEvent();
    this.setTotalTimeObj();
    this.setProgressDomInfo();
    this.initProgressStyleInfo();
  },
  methods: {
    setProgressDomInfo: function() {
      var htmlZoom = $('html').css("zoom");
      var domInfo = this.getProgressDomInfo();

      this.zoomSize = parseFloat(htmlZoom);
      this.progressLeft = domInfo.left * this.zoomSize;
      this.progressWidth = domInfo.width;
      this.setDomWidthWithMouve();
      
    },
    setDomWidthWithMouve: function() {
      this.dragWidth = $(".progress-content>span").innerWidth();
      this.referTimeWidth = $(".progress-time-box>strong").innerWidth();
    },
    initProgressStyleInfo: function() {
      this.setDragLocation(0);
      this.setProgressWidth(0);
    },
    getProgressDomInfo: function(key) {
      // {top: 349, left: 51}
      var offsetInfo = $('.play-progress-box').offset();
      var w = $('.play-progress-box').width();
      var h = $('.play-progress-box').height();
      offsetInfo.width = w;
      offsetInfo.height = h;

      return key ? offsetInfo[key] : offsetInfo;
    },
    // 鼠标事件 start
    bindMouseEvent: function() {
      var _this = this;

      $(".play-progress-box").mouseover(function(e) {
        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;
        left = left / _this.zoomSize;

        _this.setProgressDomInfo();
        _this.setDomWidthWithMouve();
        _this.setMouseReferLineLocation(left);
      })
      $(".play-progress-box").mousemove(function(e) {
        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;
        left = left / _this.zoomSize;

        _this.setReferLineTime(left);
        _this.setReferTimeByLeft(left);
        _this.setMouseReferLineLocation(left);
      })
      $(".play-progress-box").mouseleave(function(e) {
        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;
        left = left / _this.zoomSize;
      })
      $(".play-progress-box").click(function(e) {
        var pageX = e.pageX;
        var left = pageX - _this.progressLeft;
        left = left / _this.zoomSize;

        _this.setPlayPercentByLeft(left);
        _this.setDragInfoByMouseLeft(left);
        _this.setProgressWidth(left);
      })
    },
    // 鼠标事件 end
    // 设置dom显示信息 start
    setPlayPercentByLeft: function(left) {
      var totalW = this.progressWidth;
      var leftNum = left / totalW;
      var point = leftNum.toFixed(3);

      this.$emit('setPlayProgress', point);
    },
    setProgressByPercent: function() {
      var _this = this;

      var percent = Math.min(Math.max(this.percentNumber, 0), 1);
      var left = (percent * this.progressWidth).toFixed(3);

      if (left > 0) {
        _this.setProgressWidth(left);
        _this.setDragInfoByMouseLeft(left);
      }
    },
    getLeftBoundaryValue: function(moveleft,width) {
      var maxW = this.progressWidth - width;
      var left = moveleft - width / 2;
      var moveLeft = left > 0 ? left : 0;
      var showLeft = moveLeft > maxW ? maxW : moveLeft;

      return showLeft;
    },
    setReferTimeByLeft: function(left) {
      var referW = this.referTimeWidth;
      var showLeft = this.getLeftBoundaryValue(left,referW);

      this.setMouseReferTimeLocation(showLeft);
    },
    setDragInfoByMouseLeft: function(mouseLeft) {
      var dragW = this.dragWidth;
      var showLeft = this.getLeftBoundaryValue(mouseLeft,dragW);

      this.setDragLocation(showLeft);
    },
    setProgressWidth: function(width) {
      $(".progress-content>strong").css({
        'width': width
      })
    },
    setMouseReferLineLocation: function(left) {
      $(".progress-content>em").css({
        'left': left + 'px'
      })
    },
    setMouseReferTimeLocation: function(left) {
      $(".progress-time-box>strong").css({
        'left': left + 'px'
      })
    },
    setDragLocation: function(left) {
      $(".progress-content>span").css({
        'left': left + 'px'
      })
    },
    setPlayProgressShowTime: function() {

    },
    setReferLineTime: function(left) {
      var time = this.formatTimeByLeft(left);
      this.progressTimeStr = this.getShowCurrentTime(time);
    },
    formatTimeByLeft: function(left) {
      var totalW = this.progressWidth;
      var leftNum = left / totalW;
      var point = leftNum.toFixed(3);
      var time = this.totalTime * point;
      time = time.toFixed(3);
      
      return time;
    },
    // 设置dom显示信息 end
    setTotalTimeObj: function() { 
      this.totalTimeObj = this.formatSeconds(this.totalTime);
    },
    getShowCurrentTime: function(playTime) {
      var curTime = playTime || 0;
      var curTimeObj = this.formatSeconds(curTime);
      var curFomatTime = this.formatCurrentTime(curTimeObj);
      var formatShowStr = this.formatShowTime(curFomatTime);

      return formatShowStr;
    },
    // 时间换算
    formatShowTime: function(timeObj) {
      var showStr = '';
      var s = timeObj.s;
      var m = timeObj.m;
      var h = timeObj.h;

      if (h) {
        showStr += h + ":";
      }
      if (m) {
        showStr += m + ":";
      }
      if (s) {
        showStr += s;
      }

      return showStr;
    },
    formatCurrentTime: function(currentTimeObj) {
      var totalTimeObj = this.totalTimeObj;
      var curTimeObj = {};

      curTimeObj.s = totalTimeObj && totalTimeObj.s ? (currentTimeObj.s ? currentTimeObj.s : '00') : null;
      curTimeObj.m = totalTimeObj && totalTimeObj.m ? (currentTimeObj.m ? currentTimeObj.m : '00') : null;
      curTimeObj.h = totalTimeObj && totalTimeObj.h ? (currentTimeObj.h ? currentTimeObj.h : '00') : null;

      return curTimeObj;
    },
    formatSeconds: function(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0;// 分
      var hourTime = 0;// 小时
      var formatTimeObj = {};

      if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if(minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }

      var sec = parseInt(secondTime);
      formatTimeObj.s = sec > 9 ? sec + '' : '0' + sec;

      if(minuteTime > 0) {
        var min = parseInt(minuteTime);
        min = min > 9 ? min : '0' + min;
        formatTimeObj.m = min + '';
      } else {
        formatTimeObj.m = '00';
      }

      if(hourTime > 0) {
        var hour = parseInt(hourTime);
        hour = hour > 9 ? hour : '0' + hour;
        formatTimeObj.h = hour + '';
      }

      return formatTimeObj;
    }
  },
  watch: {
    totalTime: function() {
      this.setTotalTimeObj();
    },
    percentNumber: function() {
      this.setProgressByPercent();
    },
    fullStatus: function() {
      var _this = this;
      setTimeout(function() {
        _this.setProgressDomInfo();
      }, 300)
    }
  }
}
</script>
<style lang="less" scoped>
  .play-progress-box {
    position: relative;
    width: 100%;
    height: 100%;
    .progress-time-box {
      position: absolute;
      top: -18px;
      width: 100%;
      height: 15px;
      &>strong {
        display: inline-block;
        position: absolute;
        bottom: 0;
        font-size: 12px;
        padding: 2px 4px;
        border-radius: 2px;
        transition: opacity 0.3s ease;
        background: #FF8B2E;
        opacity: 0;
        color: #fff;
      }
      &>span {
        z-index: 9;
      }
      &>strong {
        z-index: 10;
      }
    }
    .progress-content {
      position: relative;
      align-self: flex-end;
      width: 100%;
      height: 3px;
      // height: 100%;
      transition: height 0.3s ease;
      background: #fff;
      &>strong, &>span {
        display: block;
      }
      &>strong {
        // width: 0%;
        width: 0;
        height: 100%;
        background: #FF8B2E;
      }
      &>span {
        position: absolute;
        top: -3px;
        left: 20%;
        width: 20px;
        height: 20px;
        transition: opacity 0.3s ease;
        border-radius: 20px;
        background: #FF8B2E;
        z-index: 9;
        opacity: 0;
      }
      &>em {
        display: none;
        position: absolute;
        top: 0;
        // left: 50%;
        width: 1px;
        height: 100%;
        z-index: 8;
        background: #000;
      }
    }
  }
  .play-progress-box:hover {
    .progress-content {
      height: 100%;
       &>span { 
          opacity: 1;
       }
       &>em {
         display: block;
       }
    }
    .progress-time-box {
      &>strong {
        opacity: 1;
      }
    }
  }
  .el-progress-box {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/video_progress_cpn.vue